import { DirectoryEffects } from './directory/directory.effects';
import { RequestsEffects } from './requests/requests.effects';
import { CompaniesEffects } from './companies/companies.effects';
import { ReferenceEffects } from './reference/reference.effects';
import { UsersEffects } from './users/users.effects';
import { FeatureFlagsEffects } from './feature-flags/feature-flags.effects';
import { FileDetailsEffects } from './file-details/file-details.effects';

export const AppEffects = [
  DirectoryEffects,
  RequestsEffects,
  CompaniesEffects,
  FileDetailsEffects,
  ReferenceEffects,
  UsersEffects,
  FeatureFlagsEffects,
];
